import callAPiBase from './base';

const messagesApi = {
  get: ({ Room, conversationStatus }: { Room: string, conversationStatus: number }) =>
    callAPiBase({
      endpoint: `/api/messages/user?Room=${Room}&conversationStatus=${conversationStatus}`,
      method: 'GET',
      useToken: true,
    }),
};

export { messagesApi };
export default messagesApi;
